import { render, staticRenderFns } from "./baseivr.vue?vue&type=template&id=6fb58505"
import script from "./baseivr.vue?vue&type=script&lang=js"
export * from "./baseivr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports